import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { DocumentInfoPopupComponent } from "@app/views/contact-us/document-info-popup/document-info-popup.component";
import { TranslateModule } from "@ngx-translate/core";
import { FileUploadComponent } from "@shared/components/file-upload/file-upload.component";
import { RequestNatureOptions } from "@shared/enums/request-nature-options";
import { BaseRef } from "@shared/models/BaseRef";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "app-file-upload-section",
  standalone: true,
  imports: [CommonModule, ButtonModule, FileUploadComponent, TranslateModule, DocumentInfoPopupComponent],
  templateUrl: "./file-upload-section.component.html",
})
export class FileUploadSectionComponent {
  @ViewChild("fileUpload") fileUpload: FileUploadComponent | undefined;

  selectedFile!: { file: File; docType: string } | null;

  showDocumentInfoPopup = false;

  @Input() documentTypes: { code: string; shortLabel: string }[] = [];
  @Input() requestNature!: string | null;
  @Input() documentTypesToDisplay: BaseRef[] = [];
  @Input() enableDocumentUpload = false;
  @Input() showMandatoryFileUploadMessage = false;
  @Input() uploadedFiles: { file: File; docType: string }[] = [];

  @Output() filesChanged = new EventEmitter<{ file: File; docType: string }[]>();

  onFileSelected(file: File): void {
    this.selectedFile = { file: file, docType: "" };
    this.showDocumentInfoPopup = true;
  }

  onRemoveFile(index: number): void {
    this.uploadedFiles.splice(index, 1);
    this.filesChanged.emit(this.uploadedFiles);
  }

  getFileTypeFromCode(code: string): string {
    const documentType = this.documentTypes.find(type => type.code === code);
    return documentType ? documentType.shortLabel : "";
  }

  onCancelDocumentInfo(): void {
    this.showDocumentInfoPopup = false;
    this.fileUpload?.clearDocument();
  }

  onSaveDocumentInfo(type: string): void {
    if (this.requestNature === RequestNatureOptions.ContractualDocuments) {
      // Check if a file of the same type already exists
      const existingFileIndex = this.uploadedFiles.findIndex(file => file.docType === type);

      if (existingFileIndex !== -1) {
        // Remove the old file if it exists
        this.uploadedFiles.splice(existingFileIndex, 1);
      }
    }

    if (this.selectedFile) {
      // Add the new file
      this.selectedFile.docType = type;
      this.uploadedFiles.push(this.selectedFile);
      this.selectedFile = null;
    }

    this.showDocumentInfoPopup = false;
    this.fileUpload?.clearDocument();
    this.filesChanged.emit(this.uploadedFiles);
  }
}
